import { createContext, useContext } from 'react';
import { MentionContextProps } from './RichEditor.type';

const MentionContext = createContext({ renderMention: () => null } as MentionContextProps);
export const MentionContextProvider = MentionContext.Provider;
export const useMentionContext = () => useContext(MentionContext);
